<template>
  <div v-if="object">
    <div class="row text-white" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{item.object.name}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <base-input label="Наименование"
                    v-model="object.name"
                    :placeholder="object.name">
        </base-input>
      </div>
      <div class="col-md-4">
        <slot name="label">
          <label class="control-label">
            Нормативный период
          </label>
        </slot>
        <br/>
        <slot>
          <select name="onpage" v-model="object.lifeTime">
            <option v-for="(item, index) in periods" :key="index" :value="item.value">{{ item.name }}</option>
          </select>
        </slot>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <textarea rows="4" cols="10"
                  class="form-control"
                  placeholder="Справочная комплектация"
                  v-model="object.referenceContent">
        </textarea>
      </div>
    </div>
    <br/>

    <div class="row">
      <div class="col-md-2">
        Базовые компоненты
      </div>
      <div class="col-md-10">
        <div class="row" v-for="(category, index) in object.content" :key="index">
          <div class="col-md-8">
            <p>
              {{category.name}}
            </p>
          </div>
          <div class="col-md-4">
            <div class="col-md-8">
              Удалить
              <i class="tim-icons icon-simple-remove" v-on:click="removeCategory(index)" style="margin-right: 10px"></i>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <items-option :label="'Категориия номенклатуры'" :object="newCategory" @update="setNewCategory" :type="'productCategory'">
            </items-option>
          </div>
          <div class="col-md-8">
            Добавить
            <i class="tim-icons icon-simple-add" v-on:click="addCategory()" style="margin-right: 10px"></i>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import BaseInput from "@/components/Inputs/BaseInput";
import {longAsStringDate} from "@/services/utils";
import {getPeriods} from "@/services/periods-service";

export default {
  components: {
    BaseInput
  },
  props:{
    item: {},
    index: null,
    type: null
  },
  data() {
    return {
      socket: null,
      object: null,
      sexArray: [{name: 'М', value: 'MALE'}, {name: 'Ж', value: 'FEMALE'}, {name: 'нет данных', value: 'UNKNOWN'}],
      periods: getPeriods(),
      newCategory: null,
      inSave: false
    }
  },
  methods: {
    convertDate(time) {
      return time ? longAsStringDate(time) : "-";
    },
    fieldView(data) {
      return data ? data : '-';
    },
    toView() {
      this.$emit('toView');
    },
    async save() {
      this.inSave = true;
      try {
        let renewed = await this.$repo.save(this.object, this.type);
        if (renewed) {
          this.item.object = renewed;
          this.item.id = renewed.id;
          this.object = JSON.parse(JSON.stringify(renewed));
          this.inSave = false;
          this.toView();
        }
      } catch(error) {
        this.inSave = false;
      }
    },
    removeCategory(index) {
      this.object.content.splice(index, 1);
    },
    setNewCategory(value) {
      this.newCategory = value;
    },
    addCategory() {
      if (this.newCategory) {
        if (!this.object.content) {
          this.object.content = [];
        }
        this.object.content.push(JSON.parse(JSON.stringify(this.newCategory)));
        this.newCategory = null;
      }
    }
  },
  mounted() {
    this.object = JSON.parse((JSON.stringify(this.item.object)));
  }
}
</script>
